module.exports = __webpack_public_path__ + "img/73ff2e5.png";